import { createContext, useContext } from "react";
import { getAthleteChallenges } from "../api/user";
import { useAuth } from "./AuthContext";
import { useQuery } from "@tanstack/react-query";

const ChallengesContext = createContext();

export function ChallengesProvider({ children }) {
  const { user } = useAuth();

  const challengesQuery = useQuery({
    queryKey: ["challenges", user.id],
    queryFn: getAthleteChallenges,
    staleTime: 12 * 60 * 60 * 1000,
  });

  if (challengesQuery.isFetched) {
    console.log(challengesQuery.data);
  }

  let contextData = {
    challenges_data: challengesQuery.data,
  };
  return (
    <ChallengesContext.Provider value={contextData}>
      {challengesQuery.isFetched && children}
    </ChallengesContext.Provider>
  );
}

export default function useChallenges() {
  return useContext(ChallengesContext);
}
